import type { ThemeData } from '../models';
import { defaultTheme } from './defaultTheme';

export const idStainMouthwashTheme: ThemeData = {
  ...defaultTheme,
  homeHero: {
    default: {
      media: {
        mobile: {
          src: 'https://cdn.shopify.com/videos/c/o/v/c8d63f20a5c742fc91c03601cef07a79.mp4',
          height: 272,
          width: 414,
        },
        desktop: {
          src: 'https://cdn.shopify.com/videos/c/o/v/b8d6bc574c264e728b4e47a58908f064.mp4',
          height: 640,
          width: 760,
        },
        alt: 'I am a mouthwash image',
        to: '/products/id-stain-mouthwash/',
      },
      content: {
        title: 'The viral gunk mouthwash',
        description:
          'Target the gunk your toothbrush may be leaving behind and help maintain your white teeth with our best selling mouthwash.',
        button: {
          text: 'Shop now',
          to: '/products/id-stain-mouthwash/',
          width: 'full-width',
          size: 'md',
        },
      },
    },
  },
  marqueeData: {
    default: {
      text: 'Save on select products in our available bundles',
      to: '/collections/products',
    },
  },
};
